module.exports = __webpack_public_path__ + "img/CB7846_753C22_AB5C32_B46C3C-256px.f963e723.png";